import { render, staticRenderFns } from "./dashboard.html?vue&type=template&id=34ba8e44&scoped=true&"
import script from "./dashboard.js?vue&type=script&lang=js&"
export * from "./dashboard.js?vue&type=script&lang=js&"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=34ba8e44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ba8e44",
  null
  
)

export default component.exports